import React from 'react';
import { Row, Col } from 'antd';
import { HeaderStep } from './Header';
import { ContentStep } from './Content';
import type { Step } from '../types';

interface StepProps {
	steps: Step[];
}

export function StepComponent(props: Readonly<StepProps>): JSX.Element {
	return (
		<Row justify="center">
			<Col>
				<HeaderStep {...props} />
			</Col>
			<Col span={24}>
				<ContentStep {...props} />
			</Col>
		</Row>
	);
}
